module.exports = __webpack_public_path__ + "img/co2_green.00b0bc36.svg";